import { namespace } from 'vuex-class';
import { StopWatch } from '@signing-page/tracking/helpers/tracking.helper';
import type { ITrackingState } from '@signing-page/tracking/store/tracking.types';

export const trackingNamespace = 'tracking';
export const Tracking = namespace(trackingNamespace);

export function getDefaultState(): ITrackingState {
  return {
    currentDocumentPages: [],
    pageViewStopWatch: new StopWatch(),
    pageViewStopWatchPaused: true,
    suspendPageTracking: false,
    trackingDisabled: true,
  };
}

export enum ETrackingAction {
  SetCurrentDocumentPages = 'setCurrentDocumentPages',
  TrackFieldClick = 'trackFieldClick',
  TrackVideo = 'trackVideo',
  TrackVisitTime = 'trackVisitTime',
  TrackContentLinkClick = 'trackContentLinkBlockClick',
  StartPageViewStopWatch = 'startPageViewStopWatch',
  ResetPageViewStopWatch = 'resetPageViewStopWatch',
  PausePageViewStopWatch = 'pausePageViewStopWatch',
  ResumePageViewStopWatch = 'resumePageViewStopWatch',
  SuspendPageTracking = 'suspendPageTracking',
  ResumePageTracking = 'resumePageTracking',
  EnableTracking = 'enableTracking',
  DisableTracking = 'disableTracking',
}

export enum ETrackingMutation {
  SetCurrentDocumentPages = 'setCurrentDocumentPages',
  SetPageViewStopWatchPaused = 'setPageViewStopWatchPaused',
  SetSuspendPageTracking = 'setSuspendPageTracking',
  SetTrackingDisabled = 'setTrackingDisabled',
}

export enum ETrackingGetter {
  PageViewStopWatchPaused = 'pageViewStopWatchPaused',
}
